export const DEFAULT_MARKUP = 1.05;
export const enum PRODUCT_TYPE  {
    PHONE = 'phone',
    EMAIL ='email',
    WHATSAPP = 'whatsapp',
    PRODUCT_REBILLING = 'product_rebilling'
}
export const enum SUBSCRIPTION_STATUS {
  ACTIVE = 'active',
  TRIALING = 'trialing',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  CANCELLED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired'
}

export const INACTIVE_STATUS = ['past_due', 'unpaid', 'canceled', 'incomplete', 'incomplete_expired'];

export const LC_EMAIL_BASEPRICE = 0.000675;

export const enum SUSPEND_REASONS {
  INVALID_STATE = 'subscription created with invalid status',
  SUBSCRIPTION_SYNC = 'subscription sync'
}

export const enum LC_TYPE {
  LC_PHONE = 'lc_phone',
  LC_EMAIL = 'lc_email'
}

export const enum LCEmailState {
  ENABLED = 'enabled',
  NOT_ENABLED = 'not_enabled'
}
export const SAAS_ASSETS_BASE_URL = "https://storage.googleapis.com/preview-production-assets/saas/img";
export const IMAGE_AI_BASE_PRICE = 0.06;

export const CUSTOM_AGENCIES_PERMISSIONS = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'beta' ? {
  'tudfVdx3VWoVLRby2OjA': {
    tabs: ['My Staff', 'Phone Numbers', 'Email Services', 'Conversations', 'Conversation Providers', 'Conversation AI', 'common.sidebar.conversations', 'common.sidebar.myStaff', 'common.sidebar.phoneNumbers', 'common.sidebar.emailServices', 'common.sidebar.conversationProviders'],
    routes: ['staff', 'team-v2', 'teams-v2', 'phone-number-v2', 'smtp-service-v2', 'conversations-v2', 'conversations', 'conversation_providers', 'conversation-ai-settings'],
    userType: ['account']
  }
} : {
  'Fk0xgtDJDlSn6N5wj8oZ': {
    tabs: ['My Staff', 'Phone Numbers', 'Email Services', 'Conversations', 'Conversation Providers', 'Conversation AI', 'common.sidebar.conversations', 'common.sidebar.myStaff', 'common.sidebar.phoneNumbers', 'common.sidebar.emailServices', 'common.sidebar.conversationProviders'],
    routes: ['staff', 'team-v2', 'teams-v2', 'phone-number-v2', 'smtp-service-v2', 'conversations-v2', 'conversations', 'conversation_providers', 'conversation-ai-settings'],
    userType: ['account']
  }
}

export const TEST_AGENCIES = ['YuTUZlUtrwBtvmgByZDW', 'Ydk7Yx1VsHhacT39iE4Z','5DP4iH6HLkQsiKESj6rh', '4jmzV68Y7eDq2tFXlpva', 'w6dADQRzRL23SiVdK5VL'];
